import React, { Component } from 'react'

import ResultsList from './ResultsList'

export default class InlineResults extends Component {
	constructor(props) {
		super(props)
	}

	componentDidMount() {
		document.querySelector('.section-search').addEventListener('keydown', this.props.handleKeydown, false)
	}

	componentWillUnmount() {
    document.querySelector('.section-search').removeEventListener('keydown', this.props.handleKeydown, false)
  }

	render() {
		const iconClass = this.props.loading ? 'loading' : ''

		return (
			<div>
				<div className="section-search-input">
				  <input
            type="text"
            autoComplete="off"
            name="iq"
            className="nav-search-input"
            placeholder="Search"
            value={this.props.searchTerm}
            onChange={this.props.handleChange}
            ref={this.props.searchInput}
          />
          {this.props.active && (
          	<i className={iconClass}></i>
          )}
				</div>
				{this.props.active && (
					<div className="section-results-wrapper search-results-wrapper">
								<ResultsList 
									groups={this.props.groups} 
									focusable={this.props.focusable} 
									selected={this.props.selected}
									selectResult={this.props.selectResult}
								/>
					</div>
				)}
			</div>
		)
	}
}